import { Row, Col } from "react-bootstrap";
import { productsArray } from "../productsStore";
import ProductCard from "../components/ProductCard";

function Store() {
  return (
    <>
      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, rgba(20, 25, 54, 0.85) 0%, rgba(7, 48, 100, 0.75) 100%)",
          borderRadius: "16px",
          padding: "60px 40px",
          marginBottom: "50px",
          color: "white",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            fontWeight: "700",
            marginBottom: "20px",
            color: "white",
          }}
        >
          Cash Box Products
        </h1>
        <p
          style={{
            fontSize: "1rem",
            opacity: 0.85,
            maxWidth: "600px",
            margin: "0 auto",
            lineHeight: "1.6",
          }}
        >
          The store offers fully assembled systems and parts for the Cash Box.
        </p>
      </div>

      <Row xs={1} md={2} lg={3} className="g-4">
        {productsArray.map((product, idx) => (
          <Col key={idx}>
            <ProductCard product={product} />
          </Col>
        ))}
      </Row>
    </>
  );
}

export default Store;
